import classes from "./button.module.css";

export const EditButton = ({onClick}) => {
    return (
        <button
            type="button"
            onClick={onClick}
            aria-label="Редактировать"
            className={`${classes.iconBtn} ${classes.edit}`}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M12 20h9"/>
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
            </svg>
        </button>
    )
};
